const _browserCanPlayWebm = () => {
    const video = document.createElement('video');
    return video.canPlayType('video/webm; codecs="vp8, vorbis"') === 'probably';
};
const _webMHelperInfo = () => {
    let element = document.getElementsByClassName('webm-helper-info');
    if(element.length === 0) {
        return;
    }
    if(!_browserCanPlayWebm()) {
        element = element[0];
        element.classList.remove('d-none');
        element.style.cursor = 'pointer';
        $(element).tooltip();
    }
};
const _showProfilePicturePreview = event => {
    if(event.target.files.length === 0) {
        return;
    }
    const imagePreview = document.getElementById('profile-picture').querySelector('img');
    imagePreview.src = URL.createObjectURL(event.target.files[0]);
    document.getElementById('profile-picture').classList.remove('d-none');
    document.getElementById('profile-picture-no-image').classList.add('d-none');
    document.getElementsByName('reset-profile-picture')[0].remove()
};

const _removeProfilePicture = () => {
    document.getElementById('profile-picture').classList.add('d-none');
    document.getElementById('profile-picture-no-image').classList.remove('d-none');
    const input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', 'reset-profile-picture');
    input.setAttribute('value', 'true');
    document.getElementById('profile-picture').append(input);
};

export {
    _webMHelperInfo as webMHelperInfo,
    _showProfilePicturePreview as showProfilePicturePreview,
    _removeProfilePicture as removeProfilePicture
};
